/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface PaymentTestDTO
 */
export interface PaymentTestDTOOptional {
  /**
   *
   * @type {string}
   * @memberof PaymentTestDTO
   */
  clientSecret?: string;
  /**
   *
   * @type {string}
   * @memberof PaymentTestDTO
   */
  sessionClientSecret?: string;
}

export interface PaymentTestDTO extends PaymentTestDTOOptional {
  /**
   *
   * @type {string}
   * @memberof PaymentTestDTO
   */
  clientSecret?: string;
  /**
   *
   * @type {string}
   * @memberof PaymentTestDTO
   */
  sessionClientSecret?: string;
}

export interface PaymentTestDTOTrackedI {
  /**
   *
   * @type {string}
   * @memberof PaymentTestDTO
   */
  clientSecret?: string;
  clientSecretIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PaymentTestDTO
   */
  sessionClientSecret?: string;
  sessionClientSecretIsSet: boolean;
}

transformDatesMap.set("PaymentTestDTO", function (model: PaymentTestDTO) {});

export type PaymentTestDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  clientSecret: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  sessionClientSecret: PropertyMeta<MetaTypeBase<string>>;
}>;

export var PaymentTestDTOMeta: PaymentTestDTOMetaI = {} as PaymentTestDTOMetaI;
PaymentTestDTOMeta = typeMeta("PaymentTestDTO", {
  clientSecret: propertyMeta(
    "clientSecret",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  sessionClientSecret: propertyMeta(
    "sessionClientSecret",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
});

const metaI = PaymentTestDTOMeta;

registerMeta(() => {});

export class PaymentTestDTOTracked implements PaymentTestDTOTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  clientSecret__I?: string = undefined;
  clientSecretIsSet: boolean = false;
  set clientSecret(v: undefined | string) {
    if (v !== undefined) {
      this.clientSecret__I = v;
      this.clientSecretIsSet = true;
    } else {
      this.clientSecret__I = v || undefined;
      this.clientSecretIsSet = false;
    }
    this.changeTracker = true;
  }
  get clientSecret() {
    return this.clientSecret__I;
  }
  sessionClientSecret__I?: string = undefined;
  sessionClientSecretIsSet: boolean = false;
  set sessionClientSecret(v: undefined | string) {
    if (v !== undefined) {
      this.sessionClientSecret__I = v;
      this.sessionClientSecretIsSet = true;
    } else {
      this.sessionClientSecret__I = v || undefined;
      this.sessionClientSecretIsSet = false;
    }
    this.changeTracker = true;
  }
  get sessionClientSecret() {
    return this.sessionClientSecret__I;
  }
  constructor(config?: PaymentTestDTOOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: PaymentTestDTOOptional,
    options?: AssignOptions,
  ): PaymentTestDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.clientSecret &&
      this.clientSecretApplyFilter(optionsRequired.filter)
    ) {
      this.clientSecret = config.clientSecret;
      if (optionsRequired.unassign) this.clientSecretIsSet = false;
      else this.clientSecretIsSet = true;
    }
    if (
      config.sessionClientSecret &&
      this.sessionClientSecretApplyFilter(optionsRequired.filter)
    ) {
      this.sessionClientSecret = config.sessionClientSecret;
      if (optionsRequired.unassign) this.sessionClientSecretIsSet = false;
      else this.sessionClientSecretIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PaymentTestDTOTrackedI {
    const cloned = {} as PaymentTestDTOTrackedI;
    if (
      this.clientSecretIsSetDeep() &&
      this.clientSecretApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.clientSecretIsSet = true;
      cloned.clientSecret = this.clientSecret;
    } else {
      //cloned.clientSecretIsSet = false
    }
    if (
      this.sessionClientSecretIsSetDeep() &&
      this.sessionClientSecretApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.sessionClientSecretIsSet = true;
      cloned.sessionClientSecret = this.sessionClientSecret;
    } else {
      //cloned.sessionClientSecretIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PaymentTestDTOTrackedI {
    if (!this.clientSecretApplyFilter(filter)) this.clientSecretIsSet = false;

    if (!this.sessionClientSecretApplyFilter(filter))
      this.sessionClientSecretIsSet = false;

    return this;
  }
  clientSecretApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentTestDTOMeta.clientSecret,
      PaymentTestDTOMeta,
      this.clientSecret,
      this,
    );
  }
  clientSecretIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.clientSecretIsSet && this.clientSecretApplyFilter(filter))
      return true;

    return false;
  }
  sessionClientSecretApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentTestDTOMeta.sessionClientSecret,
      PaymentTestDTOMeta,
      this.sessionClientSecret,
      this,
    );
  }
  sessionClientSecretIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.sessionClientSecretIsSet &&
      this.sessionClientSecretApplyFilter(filter)
    )
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.clientSecretIsSetDeep(filter)) return true;
    if (this.sessionClientSecretIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
